(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["babymom-instagram"] && !Shopify.designMode) return;
  try {
    
(() => {
const loadEmbeds = () => {
if (window.instgrm && window.instgrm.Embeds) { window.instgrm.Embeds.process(); return; }
if (document.querySelector('script[data-bm-instagram-script]')) return;
const script = document.createElement('script');
script.src = 'https://www.instagram.com/embed.js';
script.async = true;
script.dataset.bmInstagramScript = '';
script.addEventListener('load', () => window.instgrm && window.instgrm.Embeds && window.instgrm.Embeds.process());
document.head.appendChild(script);
};
const initialize = root => {
root.querySelectorAll('[data-bm-instagram]').forEach(section => {
if (section.dataset.bmInstagramReady) return;
section.dataset.bmInstagramReady = 'true';
if ('IntersectionObserver' in window) {
const observer = new IntersectionObserver(entries => { if (entries.some(entry => entry.isIntersecting)) { loadEmbeds(); observer.disconnect(); } }, { rootMargin: '240px' });
observer.observe(section);
} else { loadEmbeds(); }
});
};
initialize(document);
document.addEventListener('shopify:section:load', () => initialize(document));
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
